<template>
  <div>
    <!-- <Header /> -->

    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    <div class="flex">
      <SideBar />

      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl overflow-y-auto heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <div class="flex flex-col gap-5 pt-5">
          <div class="p-6">
            <MonthChart />
          </div>

          <div
            class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-4 gap-6 p-6"
            v-if="studentlist"
          >
            <!-- Student Card -->
            <router-link :to="{ name: 'AdminStudentDetail' }" class="group">
              <div
                class="bg-white shadow-md hover:shadow-xl rounded-2xl p-6 flex flex-col gap-4 border border-gray-100 transition-all duration-300 hover:scale-[1.02]"
              >
                <div class="flex justify-between items-start">
                  <div class="flex items-center gap-3">
                    <div
                      class="bg-gradient-to-br from-blue-500 to-blue-700 p-3 rounded-xl shadow-lg"
                    >
                      <svg
                        class="w-6 h-6 text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
                        ></path>
                      </svg>
                    </div>
                    <div>
                      <h2 class="font-semibold text-gray-800 text-lg">
                        Learner
                      </h2>
                      <p class="text-xs text-gray-400">
                        Total enrolled Leaner
                      </p>
                    </div>
                  </div>
                  <div
                    class="bg-green-50 text-green-600 text-sm font-semibold px-3 py-1 rounded-full shadow-sm flex gap-1 items-center"
                  >
                    +{{ studentlist.recent_student_percent }}%
                  </div>
                </div>

                <div class="border-t border-gray-100 pt-3">
                  <div class="flex items-baseline justify-between mb-3">
                    <div>
                      <p class="text-3xl font-bold text-gray-900">
                        <span v-if="studentlist.recent_student_count">{{
                          studentlist.recent_student_count
                        }}</span>
                        <span v-else>0</span>
                      </p>
                      <p class="text-xs text-gray-500 font-medium">
                        Current Month
                      </p>
                    </div>
                    <div class="text-right">
                      <p class="text-2xl font-bold text-blue-600">
                        <span v-if="studentlist.student_count">{{
                          studentlist.student_count
                        }}</span>
                        <span v-else>0</span>
                      </p>
                      <p class="text-xs text-gray-500 font-medium">
                        Total Leaner
                      </p>
                    </div>
                  </div>
                  <!-- <div class="w-full bg-gray-100 rounded-full h-1.5">
                    <div
                      class="bg-blue-500 h-1.5 rounded-full"
                      :style="{
                        width:
                          (studentlist.recent_student_count /
                            studentlist.student_count) *
                            100 +
                          '%',
                      }"
                      v-if="
                        studentlist.student_count &&
                        studentlist.recent_student_count
                      "
                    ></div>
                  </div> -->
                  <!-- <p class="text-xs text-gray-400 mt-2">
                    {{
                      (
                        (studentlist.recent_student_count /
                          studentlist.student_count) *
                        100
                      ).toFixed(1)
                    }}% of total
                  </p> -->
                </div>
              </div>
            </router-link>

            <!-- Staff Card -->
            <router-link :to="{ name: 'AdminStaffDetails' }" class="group">
              <div
                class="bg-white shadow-md hover:shadow-xl rounded-2xl p-6 flex flex-col gap-4 border border-gray-100 transition-all duration-300 hover:scale-[1.02]"
              >
                <div class="flex justify-between items-start">
                  <div class="flex items-center gap-3">
                    <div
                      class="bg-gradient-to-br from-emerald-400 to-emerald-600 p-3 rounded-xl shadow-lg"
                    >
                      <svg
                        class="w-6 h-6 text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                        ></path>
                      </svg>
                    </div>
                    <div>
                      <h2 class="font-semibold text-gray-800 text-lg">
                        Trainer
                      </h2>
                      <p class="text-xs text-gray-400">
                        Faculty & administration
                      </p>
                    </div>
                  </div>
                  <div
                    class="bg-green-50 text-green-600 text-sm font-semibold px-3 py-1 rounded-full shadow-sm flex gap-1 items-center"
                  >
                    +{{ studentlist.staff_recent_percent }}%
                  </div>
                </div>

                <div class="border-t border-gray-100 pt-3">
                  <div class="flex items-baseline justify-between mb-3">
                    <div>
                      <p class="text-3xl font-bold text-gray-900">
                        <span v-if="studentlist.staff_recent_count">{{
                          studentlist.staff_recent_count
                        }}</span>
                        <span v-else>0</span>
                      </p>
                      <p class="text-xs text-gray-500 font-medium">
                        Current Month
                      </p>
                    </div>
                    <div class="text-right">
                      <p class="text-2xl font-bold text-emerald-600">
                        <span v-if="studentlist.staff_count">{{
                          studentlist.staff_count
                        }}</span>
                        <span v-else>0</span>
                      </p>
                      <p class="text-xs text-gray-500 font-medium">
                        Total Staff
                      </p>
                    </div>
                  </div>
                  <!-- <div class="w-full bg-gray-100 rounded-full h-1.5">
                    <div
                      class="bg-emerald-500 h-1.5 rounded-full"
                      :style="{
                        width:
                          (studentlist.staff_recent_count /
                            studentlist.staff_count) *
                            100 +
                          '%',
                      }"
                      v-if="
                        studentlist.staff_count &&
                        studentlist.staff_recent_count
                      "
                    ></div>
                  </div> -->
                  <!-- <p class="text-xs text-gray-400 mt-2">
                    {{
                      (
                        (studentlist.staff_recent_count /
                          studentlist.staff_count) *
                        100
                      ).toFixed(1)
                    }}% of total
                  </p> -->
                </div>
              </div>
            </router-link>

            <!-- Department Card (Original Style with Enhancement) -->
            <router-link :to="{ name: 'AdminDepartmentDetails' }" class="group">
              <div
                class="bg-white shadow-md hover:shadow-xl rounded-2xl p-6 flex flex-col gap-4 border border-gray-100 transition-all duration-300 hover:scale-[1.02]"
              >
                <div class="flex justify-between items-start">
                  <div class="flex items-center gap-3">
                    <div
                      class="bg-gradient-to-br from-cyan-400 to-cyan-600 p-3 rounded-xl shadow-lg"
                    >
                      <svg
                        class="w-6 h-6 text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                        ></path>
                      </svg>
                    </div>
                    <div>
                      <h2 class="font-semibold text-gray-800 text-lg">
                        Module
                      </h2>
                      <p class="text-xs text-gray-400">Academic Courses</p>
                    </div>
                  </div>
                </div>

                <div class="border-t border-gray-100 pt-3">
                  <div class="flex items-center justify-between">
                    <div>
                      <p class="text-4xl font-bold text-cyan-600">
                        <span v-if="studentlist.course_count">{{
                          studentlist.course_count
                        }}</span>
                        <span v-else>0</span>
                      </p>
                      <p class="text-xs text-gray-500 font-medium mt-1">
                        Total Courses
                      </p>
                    </div>
                    <div
                      class="w-12 h-12 rounded-full bg-cyan-50 flex items-center justify-center"
                    >
                      <!-- <svg
                        class="w-6 h-6 text-cyan-500"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                        ></path>
                      </svg> -->
                      <svg
                        class="w-6 h-6 text-cyan-500"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                        ></path>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>

            <!-- Semester Card -->
            <!-- <router-link :to="{ name: 'AdminSemesterDetails' }" class="group">
              <div
                class="bg-white shadow-md hover:shadow-xl rounded-2xl p-6 flex flex-col gap-4 border border-gray-100 transition-all duration-300 hover:scale-[1.02]"
              >
                <div class="flex justify-between items-start">
                  <div class="flex items-center gap-3">
                    <div
                      class="bg-gradient-to-br from-purple-500 to-purple-700 p-3 rounded-xl shadow-lg"
                    >
                      <svg
                        class="w-6 h-6 text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                        ></path>
                      </svg>
                    </div>
                    <div>
                      <h2 class="font-semibold text-gray-800 text-lg">
                        Semesters
                      </h2>
                      <p class="text-xs text-gray-400">Academic semesters</p>
                    </div>
                  </div>
                </div>

                <div class="border-t border-gray-100 pt-3">
                  <div class="flex items-center justify-between">
                    <div>
                      <p class="text-4xl font-bold text-purple-600">
                        <span v-if="studentlist.semester_count">{{
                          studentlist.semester_count
                        }}</span>
                        <span v-else>0</span>
                      </p>
                      <p class="text-xs text-gray-500 font-medium mt-1">
                        Total Semesters
                      </p>
                    </div>
                    <div
                      class="w-12 h-12 rounded-full bg-purple-50 flex items-center justify-center"
                    >
                      <svg
                        class="w-6 h-6 text-purple-500"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                        ></path>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </router-link> -->

            <!-- <router-link :to="{ name: 'AdminBatchDetails' }" class="group">
              <div
                class="bg-white shadow-md hover:shadow-xl rounded-2xl p-6 flex flex-col gap-4 border border-gray-100 transition-all duration-300 hover:scale-[1.02]"
              >
                <div class="flex justify-between items-start">
                  <div class="flex items-center gap-3">
                    <div
                      class="bg-gradient-to-br from-amber-500 to-amber-600 p-3 rounded-xl shadow-lg"
                    >
                      <svg
                        class="w-6 h-6 text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
                        ></path>
                      </svg>
                    </div>
                    <div>
                      <h2 class="font-semibold text-gray-800 text-lg">
                        Batches
                      </h2>
                      <p class="text-xs text-gray-400">Student cohorts</p>
                    </div>
                  </div>
                </div>

                <div class="border-t border-gray-100 pt-3">
                  <div class="flex items-center justify-between">
                    <div>
                      <p class="text-4xl font-bold text-amber-600">
                        <span v-if="studentlist.batch_count">{{
                          studentlist.batch_count
                        }}</span>
                        <span v-else>0</span>
                      </p>
                      <p class="text-xs text-gray-500 font-medium mt-1">
                        Total Batches
                      </p>
                    </div>
                    <div
                      class="w-12 h-12 rounded-full bg-amber-50 flex items-center justify-center"
                    >
                      <svg
                        class="w-6 h-6 text-amber-500"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                        ></path>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </router-link> -->

            <!-- <router-link :to="{ name: 'AdminProgramsDetails' }" class="group">
              <div
                class="bg-white shadow-md hover:shadow-xl rounded-2xl p-6 flex flex-col gap-4 border border-gray-100 transition-all duration-300 hover:scale-[1.02]"
              >
                <div class="flex justify-between items-start">
                  <div class="flex items-center gap-3">
                    <div
                      class="bg-gradient-to-br from-indigo-500 to-indigo-700 p-3 rounded-xl shadow-lg"
                    >
                      <svg
                        class="w-6 h-6 text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                        ></path>
                      </svg>
                    </div>
                    <div>
                      <h2 class="font-semibold text-gray-800 text-lg">
                        Programs
                      </h2>
                      <p class="text-xs text-gray-400">Course offerings</p>
                    </div>
                  </div>
                </div>

                <div class="border-t border-gray-100 pt-3">
                  <div class="flex items-center justify-between">
                    <div>
                      <p class="text-4xl font-bold text-indigo-600">
                        <span v-if="studentlist.program_count">{{
                          studentlist.program_count
                        }}</span>
                        <span v-else>0</span>
                      </p>
                      <p class="text-xs text-gray-500 font-medium mt-1">
                        Total Programs
                      </p>
                    </div>
                    <div
                      class="w-12 h-12 rounded-full bg-indigo-50 flex items-center justify-center"
                    >
                      <svg
                        class="w-6 h-6 text-indigo-500"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                        ></path>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </router-link> -->
          </div>

          <!-- Two Column Layout -->
          <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 p-6 ">
            <!-- Department Section -->
            <div
              class="bg-white shadow-lg rounded-2xl overflow-hidden border border-gray-200 hidden"
            >
              <div
                class="px-6 py-4 border-b border-gray-200 bg-gradient-to-r from-gray-50 to-white"
              >
                <div class="flex items-center justify-between">
                  <div class="flex items-center gap-3">
                    <div>
                      <h2 class="text-xl font-semibold text-gray-800">
                        Departments
                      </h2>
                      <p class="text-xs text-gray-500">
                        Total: {{ departmentTotal || 0 }}
                      </p>
                    </div>
                  </div>
                  <div class="flex items-center gap-2">
                    <span class="text-xs text-gray-400"
                      >Manage departments</span
                    >
                  </div>
                </div>
              </div>

              <div v-if="departmentsLoading" class="p-8 text-center">
                <div
                  class="inline-block animate-spin rounded-full h-8 w-8 border-4 border-purple-500 border-t-transparent"
                ></div>
                <p class="mt-2 text-gray-500">Loading departments...</p>
              </div>

              <div v-else-if="departments.length > 0" class="p-4">
                <div
                  class="overflow-x-auto rounded-2xl border border-gray-200 bg-white shadow-sm"
                >
                  <table class="min-w-full">
                    <thead>
                      <tr class="bg-gray-100 whitespace-nowrap">
                        <th
                          class="px-4 py-3 text-left text-sm font-semibold text-textblues border-r border-gray-200"
                        >
                          S.No
                        </th>
                        <th
                          class="px-4 py-3 text-left text-sm font-semibold text-textblues border-r border-gray-200"
                        >
                          Department Name
                        </th>
                        <th
                          class="px-4 py-3 text-left text-sm font-semibold text-textblues border-r border-gray-200"
                        >
                          Program
                        </th>
                        <th
                          class="px-4 py-3 text-left text-sm font-semibold text-textblues border-r border-gray-200"
                        >
                          Students
                        </th>
                      </tr>
                    </thead>
                    <tbody class="divide-y divide-gray-50">
                      <tr
                        v-for="(list, index) in departments"
                        :key="'dept-' + list.id"
                        class="hover:bg-purple-50/30 transition-all duration-150 group"
                      >
                        <td
                          class="px-4 py-3 whitespace-nowrap border-r border-gray-200"
                        >
                          <span
                            class="inline-flex items-center justify-center w-6 h-6 bg-gray-100 rounded-lg text-xs font-semibold text-gray-600 group-hover:bg-purple-100 group-hover:text-purple-600 transition"
                          >
                            {{
                              (departmentPage - 1) * departmentPerPage +
                              index +
                              1
                            }}
                          </span>
                        </td>
                        <td
                          class="px-4 py-3 whitespace-nowrap border-r border-gray-200"
                        >
                          <router-link
                            :to="{
                              name: 'DepartmentInnerPage',
                              params: {
                                depart_id: list.id,
                                d_name: list.name,
                              },
                            }"
                            class="block"
                          >
                            <span
                              class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-purple-50 text-purple-700 text-xs font-medium transition-all duration-200 hover:bg-purple-100 hover:text-purple-800 hover:shadow-sm cursor-pointer"
                            >
                              {{ list.name || "---" }}
                            </span>
                          </router-link>
                        </td>
                        <td
                          class="px-4 py-3 whitespace-nowrap border-r border-gray-200"
                        >
                          <span class="text-sm text-gray-600">{{
                            list.program?.name || "—"
                          }}</span>
                        </td>
                        <td
                          class="px-4 py-3 whitespace-nowrap border-r border-gray-200"
                        >
                          <span
                            class="inline-flex items-center gap-1 px-2 py-0.5 bg-blue-50 text-blue-700 rounded-full text-xs font-medium"
                          >
                            {{ list.student_count || 0 }}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="mt-4">
                  <Pagination
                    :totalPages="departmentTotalPages"
                    :currentPage="departmentPage"
                    @page-changed="handleDepartmentPageChange"
                  />
                </div>
              </div>

              <div v-else class="p-8 text-center">
                <div
                  class="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-3"
                >
                  <svg
                    class="w-8 h-8 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                      d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                    />
                  </svg>
                </div>
                <p class="text-gray-500">No departments found</p>
              </div>
            </div>

            <!-- Programs Section -->
            <!-- <div
              class="bg-white shadow-lg rounded-2xl overflow-hidden border border-gray-200"
            >
              <div
                class="px-6 py-4 border-b border-gray-200 bg-gradient-to-r from-gray-50 to-white"
              >
                <div class="flex items-center justify-between">
                  <div class="flex items-center gap-3">
                    <div>
                      <h2 class="text-xl font-semibold text-gray-800">
                        Programs
                      </h2>
                      <p class="text-xs text-gray-500">
                        Total: {{ programTotal || 0 }}
                      </p>
                    </div>
                  </div>
                  <div class="flex items-center gap-2">
                    <span class="text-xs text-gray-400">Manage programs</span>
                  </div>
                </div>
              </div>

              <div v-if="programsLoading" class="p-8 text-center">
                <div
                  class="inline-block animate-spin rounded-full h-8 w-8 border-4 border-green-500 border-t-transparent"
                ></div>
                <p class="mt-2 text-gray-500">Loading programs...</p>
              </div>

              <div v-else-if="Programs.length > 0" class="p-4">
                <div
                  class="overflow-x-auto rounded-2xl border border-gray-200 bg-white shadow-sm"
                >
                  <table class="min-w-full">
                    <thead>
                      <tr class="bg-gray-100 whitespace-nowrap">
                        <th
                          class="px-4 py-3 text-left text-sm font-semibold text-textblues border-r border-gray-200"
                        >
                          S.No
                        </th>
                          <th
                          class="px-4 py-3 text-left text-sm font-semibold text-textblues border-r border-gray-200"
                        >
                          Batch
                        </th>
                        <th
                          class="px-4 py-3 text-left text-sm font-semibold text-textblues border-r border-gray-200"
                        >
                          Program Name
                        </th>
                        <th
                          class="px-4 py-3 text-left text-sm font-semibold text-textblues border-r border-gray-200"
                        >
                          Students
                        </th>
                      </tr>
                    </thead>
                    <tbody class="divide-y divide-gray-50">
                      <tr
                        v-for="(list, index) in Programs"
                        :key="'prog-' + list.id"
                        class="hover:bg-gray-50/30 transition-all duration-150 group"
                      >
                        <td
                          class="px-4 py-3 whitespace-nowrap border-r border-gray-200"
                        >
                          <span
                            class="inline-flex items-center justify-center w-6 h-6 bg-gray-100 rounded-lg text-xs font-semibold  transition"
                          >
                            {{ (programPage - 1) * programPerPage + index + 1 }}
                          </span>
                        </td>
                         <td
                          class="px-4 py-3 whitespace-nowrap border-r border-gray-200"
                        >
                          <span
                            class="inline-flex items-center gap-1 px-2 py-0.5  text-gray-500 rounded-full text-xs font-medium"
                          >
                            {{ list.batch?.year || "---" }}
                          </span>
                        </td>
                        <td
                          class="px-4 py-3 whitespace-nowrap border-r border-gray-200"
                        >
                          <router-link
                            :to="{
                              name: 'ProgramInnerPage',
                              params: {
                                program_id: list.id,
                                p_name: list.name,
                              },
                            }"
                            class="block"
                          >
                            <span
                              class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full  text-blue-600 hover:underline text-xs font-medium transition-all duration-200 cursor-pointer"
                            >
                              {{ list.name || "---" }}
                            </span>
                          </router-link>
                        </td>
                        
                        <td
                          class="px-4 py-3 whitespace-nowrap border-r border-gray-200"
                        >
                          <span
                            class="inline-flex items-center gap-1 px-2 py-0.5  text-gray-500 rounded-full text-xs font-medium"
                          >
                            {{ list.student_count || 0 }}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="mt-4">
                  <Pagination
                    :totalPages="programTotalPages"
                    @page-changed="this.programesget"
                  />
                </div>
              </div>

              <div v-else class="p-8 text-center">
                <div
                  class="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-3"
                >
                  <svg
                    class="w-8 h-8 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                    />
                  </svg>
                </div>
                <p class="text-gray-500">No programs found</p>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Admin/Header.vue";
import SideBar from "@/components/Admin/SideBar.vue";
import FlashMessage from "@/components/FlashMessage.vue";
import axios from "axios";
import { mapGetters } from "vuex";
import MonthChart from "@/components/Admin/MonthChart.vue";
import RadialChart from "@/components/Admin/RadialChart.vue";
import Pagination from "@/components/Pagination.vue";

export default {
  components: {
    Header,
    SideBar,
    FlashMessage,
    MonthChart,
    RadialChart,
    Pagination,
  },
  data() {
    return {
      messages: {
        text: "",
        type: "null",
      },
      organizationdetaill: null,
      studentlist: [],
      departments: [],
      departmentTotal: 0,
      departmentPage: 1,
      departmentTotalPages: 1,
      departmentPerPage: 10,
      currentPage: 1,
      totalPages: 1,
      perPage: 10,
      Programs: [],
      programTotal: 0,
      programPage: 1,
      programTotalPages: 1,
      programPerPage: 10,
    };
  },

  async created() {
    await this.studentlistget();
    await this.departmentget(1);
    await this.programesget(1);

    let token_id = this.userInfo.token_key;
    await axios
      .get(`${process.env.VUE_APP_API}/organization_detail/?Key=${token_id}`)
      .then((response) => {
        this.organizationdetaill = response.data.data;
      });
  },

  computed: {
    ...mapGetters(["userInfo"]),
  },

  methods: {
  
    async studentlistget() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/users-count-get/?Key=${this.userInfo.token_key}`,
        )
        .then((res) => {
          if (res.data.status == 200) {
            this.studentlist = res.data.data;
          }
        });
    },

    invitepost(el) {
      let bodyVal = {
        email: el.target.elements.studentmail.value,
        coures: this.course_title,
        user: this.userInfo.user.id,
        status: true,
      };
      this.disableStatus = true;
      this.loaders = true;
      axios
        .post(
          `${process.env.VUE_APP_API}/invitation/?Key=${this.userInfo.token_key}`,
          bodyVal,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.loaders = false;
            this.messages = {
              text: response.data.message,
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.addinvite = false;
              this.disableStatus = false;
              this.searchQuery = "";
              this.inviteget();
            }, 1500);
          } else {
            this.loaders = false;
            this.messages = {
              text: response.data.error,
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };

              this.disableStatus = false;
            }, 1500);
          }
        })

        .finally(() => {
          this.loaders = false;
        });
    },
    async departmentget(page) {
      this.programPage = page;
      await axios
        .get(
          `${process.env.VUE_APP_API}/department-filter-list/?Key=${this.userInfo.token_key}&page=${page}`,
        )
        .then((res) => {
          if (res.data.data.status == 200) {
            this.departments = res.data.data.data;
            this.departmentTotal = res.data.total;
            this.todepartmentTotalPagestalPages = res.data.total_page;
          }
        });
    },
    async programesget(page) {
      this.programPage = page;
      await axios
        .get(
          `${process.env.VUE_APP_API}/program-filter-list/?Key=${this.userInfo.token_key}&page=${page}`,
        )
        .then((res) => {
          if (res.data.data.status == 200) {
            this.Programs = res.data.data.data;
            this.programTotal = res.data.total;
            this.programPage = res.data.current_page;
            this.programTotalPages = res.data.total_page;
          }
        });
    },
    handleDepartmentPageChange(page) {
      this.fetchDepartments(page);
    },

    
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
